import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Components
import Navbar from "./Navbar";
import Footer from "./Footer";
import Notifications from "../UI/Notifications";
import SEO from "../SEO";
import { useEffect } from "react";

//
// import favIcon from "./static/";

const Layout = ({ children }) => {
  const { fetching } = useSelector((state) => state.form.uploadFile);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll({
      left: 0,
      top: 0,
      behavior: "auto",
    });
  }, [pathname]);

  return (
    <>
      <SEO
        title="Podcast XML Maker"
        name="Podcast XML Maker"
        description="An app to easily create and edit podcast XML feeds"
        websiteURL="https://podcast-xml.netlify.app/"
        favIcon="./favicon.png"
        lang="en"
      />
      <Notifications />
      {/* <Navbar /> */}
      {children}
      {fetching && (
        <div className="loading-screen">
          <div className="circle">
            <svg
              className="circle__svg"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle className="circle__svg-circle" cx="50" cy="50" r="45" />
            </svg>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Layout;
